import { TFetchError } from "@lib/api-fetcher/types";

import { TErrorMessages, TErrorResponse, TForgotPasswordFieldError } from "../types";

const mapErrorsToMessages = (
  errorResponse: TFetchError<TErrorResponse<TForgotPasswordFieldError>>
): TErrorMessages<TForgotPasswordFieldError> => {
  if (!errorResponse.response) {
    return { errorMessage: undefined, fieldErrors: undefined };
  }
  const { data } = errorResponse.response;
  const errorMessage = data?.title;
  const errorDetails = data?.detail;

  const fieldErrors = {
    email: errorDetails?.email,
  };

  return { errorMessage, fieldErrors };
};
export default mapErrorsToMessages;
